import { InfoDetailsCombinedProps } from './types';

const usePresenter = (props: InfoDetailsCombinedProps): InfoDetailsCombinedProps => {
  return props;
};

export default usePresenter;
